import { useEffect, useRef } from 'react';

/**
 * useEffect that not run on initial render
 * @param {Function} func The callback that will be executed
 * @param {Array} deps Dependencies
 */
export function useUtilsEffectNonInitial(func, deps) {
  const didMount = useRef(false);
  useEffect(() => {
    if (didMount.current) {
      func();
    } else {
      didMount.current = true;
    }
  }, deps);
}
